/** The LaunchDarkly flag that gives the CRM its Actions module, and what points to it. */
export const ACTIONS_SHOWN_FLAG = 'core-ai-actions-shown';
